import React  from "react";
import Container from "../../components/container";
import Button from "../../components/button";
import useGlobal from "../../../store";
import { ReactComponent as Check } from "./icons/add-table-col.svg";
import './tariff.scss';
import prettyFloat from "../../../scripts/helpers/pretty.float";

const Tariff = ({ timeTill = "" }) => {

  const [ globalState, globalActions ] = useGlobal();
  const { user_tariff } = globalState;

  return (

    <Container clear>

      <div className = "sign">

        <div className = "sign__content tariff">
          
          <div>

            <p className = "tariff__title">Настало время оплатить подписку!</p>

            <div className = "tariff__list__container">

              <div className = "tariff__list__container__content">

                <Check />
                <p>Наблюдайте за своими результатами и анализируйте их</p>

              </div>

              <div className = "tariff__list__container__content">

                <Check />
                <p>Считайте результат от сделки до её совершения</p>

              </div>

              <div className = "tariff__list__container__content">

                <Check />
                <p>Учитесь торговать, не теряя настоящие деньги</p>

              </div>

              <div className = "tariff__list__container__content">

                <Check />
                <p>Пишите комментарии к сделкам - почему заработали или потеряли</p>

              </div>

              <div className = "tariff__list__container__content">

                <Check />
                <p>Скалькулятор поможет не уйти в минус из за комиссии</p>

              </div>

              <div className = "tariff__list__container__content">

                <Check />
                <p>Мотивируйте себя, видя как со временем улучшаются результаты</p>

              </div>

              <div className = "tariff__list__container__content">

                <Check />
                <p>По окончанию подписки никаких авто-платежей не будет</p>

              </div>

            </div>

            <div className = "tariff__respect flex justify-center items-center">

              <div className = "tariff__respect__icon tariff__respect__icon--ava" />
              Поддержите проект!
              <div className = "tariff__respect__icon tariff__respect__icon--smile" />
              Закиньте автору респект
              <div className = "tariff__respect__icon tariff__respect__icon--money" />

            </div>

            <div className = "tariff__buttons__container">

              <div className = "tariff__buttons__container__content tariff__buttons__container__content_left">

                <p className = "tariff__buttons__container__content__text tariff__buttons__container__content__text-left">Стоимость: { user_tariff?.price }р за 30 дней</p>
                <p className = "tariff__buttons__container__content__subtext">🔥 <span>Это всего <b>{ prettyFloat( user_tariff?.price / 30 ) }</b>р в день!</span> 🔥</p>
                
                <Button
          
                  action = {() => { globalActions.tariff.pay() }}
                  text = {`Оплатить 1 месяц: ${ user_tariff?.price }р`}

                />

              </div>

            </div>

            <p className = "tariff__subtitle">Подарите себе удобный инструмент, он поможет вам стать лучше!</p>

          </div>
            
        </div>

      </div>

    </Container>

  );

}

export default Tariff;